var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2049_13695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0009 14.9997C48.0009 23.1989 41.3674 29.8324 33.1683 29.8324C29.7073 29.8324 26.5348 28.6375 24.0215 26.6598C27.4824 23.9405 29.6661 19.7379 29.6661 14.9997C29.6661 10.2615 27.4412 6.05897 24.0215 3.33965C26.5348 1.36197 29.7073 0.167114 33.1683 0.167114C41.3674 0.167114 48.0009 6.84179 48.0009 14.9997Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6859 2.99939C27.1056 5.7187 29.3305 9.92128 29.3305 14.6595C29.3305 19.3977 27.1468 23.6003 23.6859 26.3196L23.6445 26.3196C20.2248 23.6415 18 19.3977 18 14.6596C18 9.92137 20.2249 5.71879 23.6446 2.99948L23.6859 2.99939Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3348 14.9997C18.3348 10.2615 20.5597 6.05897 23.9794 3.33965C21.4661 1.36197 18.2936 0.167114 14.8326 0.167114C6.63348 0.167114 0 6.80059 0 14.9997C0 23.1989 6.63348 29.8324 14.8326 29.8324C18.2936 29.8324 21.4661 28.6375 23.9794 26.6598C20.5597 23.9817 18.3348 19.7379 18.3348 14.9997Z",
    fill: "#EB001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2049_13695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 29.6652,
    fill: "white",
    transform: "translate(0 0.167358)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardColor);
export default __webpack_public_path__ + "static/media/mastercard-color.a4d6e7fabe7abc0288b0526fe9d4204f.svg";
export { ForwardRef as ReactComponent };